export default class Button extends Phaser.GameObjects.Image {
  /**
   * on click function should listen POINTER UP event
   * btn.on('pointerup', onClickFunc, this);
   * onClickFunc should invoke onClick function
   * Notice that you should disable and enable interactivity of button during the action progress when button is clicked
   * @param scene
   * @param texture
   * @param isAtlas
   */
  constructor(scene, texture, isAtlas, table) {
    if (isAtlas) super(scene, 0, 0, scene.atlasTexture, texture);
    else super(scene, 0, 0, texture);
    this.scene = scene;
    this.table = table;
    this.texture = texture;
    this.scene.add.existing(this);
    if (this.table) this.table.poolArray.push(this);

    this.setInteractive({ cursor: "pointer" });

    this.on("pointerdown", this.scaleTween, this);
    this.on("pointerout", this.unScaleTween, this);
    // this.on('pointerup', this.onClick, this);
    this.btnClicked = false;
    this.initScale = 1;
    this.scaleTweenDuration = 50;
  }
  scaleTween() {
    if (this.btnClicked) return;
    this.initScale = this.scale;
    this.btnClicked = true;
    this.scene.tweens.add({
      targets: this,
      duration: this.scaleTweenDuration,
      ease: "Linear",
      scale: this.scale * 0.95,
    });
  }
  unScaleTween() {
    if (this.btnClicked) {
      this.btnClicked = false;
      this.scene.tweens.add({
        targets: this,
        duration: this.scaleTweenDuration,
        ease: "Linear",
        scale: this.initScale,
      });
    }
  }
  enableInteractive() {
    if (!this.active) return;
    this.setInteractive({ cursor: "pointer" });
  }
  /**
   * @param callback {function}
   */
  onClick(callback) {
    if (this.btnClicked) {
      this.btnClicked = false;
      // return new Promise(resolve => {
      this.scene.tweens.add({
        targets: this,
        duration: this.scaleTweenDuration,
        ease: "Linear",
        scale: this.initScale,
        onComplete: () => {
          callback();
        },
      });
      // })
    }
  }
}
